module.exports = __webpack_public_path__ + "354084bc08f8f447ed1d8306ea7e1b2c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/pin-to-board.svg
// module id = ./app/images/pin-to-board.svg
// module chunks = 3